export const PROPERTY_TYPES = [
  "농지",
  "임야",
  "상가",
  "주택",
  "묘터",
  "공장",
  "창고",
] as const;

export type PropertyType = (typeof PROPERTY_TYPES)[number];

export interface ListingForm {
  property_type: PropertyType | "";
  region_sido: string;
  region_sigungu: string;
  region_eupmyeondong: string;
  exact_address: string;
  area_pyeong: string;
  price_manwon: string;
  exact_lat: number | null;
  exact_lng: number | null;
  blind_lat: number | null;
  blind_lng: number | null;
  land_category: string;
  zoning: string;
  road_access: string;
  water_supply: string;
  recommended_use: string;
  description: string;
  detailed_notes: string;
  owner_contact: string;
  photos: string[];
}

export interface ListingResponse {
  id: string;
  broker_id: string;
  broker_name: string;
  property_type: PropertyType;
  region_sido: string;
  region_sigungu: string;
  region_eupmyeondong: string;
  blind_lat: number;
  blind_lng: number;
  area_pyeong: number;
  price_manwon: number;
  land_category: string;
  zoning: string;
  road_access: string;
  water_supply: string;
  recommended_use: string;
  description: string;
  status: string;
  view_count: number;
  nda_request_count: number;
  created_at: string;
  broker_is_verified?: boolean;
}

export const INITIAL_FORM: ListingForm = {
  property_type: "",
  region_sido: "",
  region_sigungu: "",
  region_eupmyeondong: "",
  exact_address: "",
  area_pyeong: "",
  price_manwon: "",
  exact_lat: null,
  exact_lng: null,
  blind_lat: null,
  blind_lng: null,
  land_category: "",
  zoning: "",
  road_access: "",
  water_supply: "",
  recommended_use: "",
  description: "",
  detailed_notes: "",
  owner_contact: "",
  photos: [],
};
